<p-card>
  <div class="flex flex-col md:px-4 md:py-2">
    <section class="flex md:hidden gap-4 mb-2">
      <span
        *ngIf="documentsInformations && documentsInformations.reference !== undefined; else referenceLoading"
        class="flex-1 text-dark inline-block"
        >{{ "storedDocuments.policyLabel" | translate
        }}<span class="text-black">{{ documentsInformations.reference }}</span></span
      >
      <ng-template #referenceLoading>
        <p-skeleton class="flex-1 h-5 self-center" />
      </ng-template>
      <button
        title="Informations"
        (click)="uploadInfo.toggle($event)">
        <i class="pi pi-info-circle text-medium_light text-xl h-7 aspect-square text-center"></i>
      </button>
    </section>
    <p-overlayPanel #uploadInfo>
      <span>{{ "storedDocuments.fileUpload.format.generalInformations" | translate }}</span>
      <ul class="list-outside list-disc ml-6 mt-2">
        <li>
          {{ "storedDocuments.fileUpload.format.listItem1" | translate }}
        </li>
        <li>
          {{ "storedDocuments.fileUpload.format.listItem2" | translate }}
        </li>
        <li>
          {{ "storedDocuments.fileUpload.format.listItem3" | translate }}
        </li>
      </ul>
    </p-overlayPanel>
    <section class="flex flex-col gap-2">
      <h2 class="text-black font-app-bold">
        {{ "storedDocuments.storageTitle" | translate }}
      </h2>
      <p-progressBar [value]="documentsInformations?.usedSpaceInPercent ?? 0">
        <ng-template pTemplate="content"></ng-template>
      </p-progressBar>
      <span
        *ngIf="documentsInformations && documentsInformations.usedSpaceInGigaBytes !== undefined; else usedSpaceLoading"
        class="text-sm"
        >{{ "storedDocuments.usedSpace" | translate: { value: documentsInformations.usedSpaceInGigaBytes } }}</span
      >
      <ng-template #usedSpaceLoading>
        <p-skeleton class="h-5 w-1/2" />
      </ng-template>
    </section>
    <section class="flex flex-col gap-6">
      <p-fileUpload
        #documentUpload
        (onSelect)="onFileSelect($event)"
        [fileLimit]="1"
        [maxFileSize]="5368709120"
        invalidFileSizeMessageSummary=""
        invalidFileSizeMessageDetail=""
        invalidFileTypeMessageSummary=""
        invalidFileTypeMessageDetail=""
        accept="image/jpg,image/jpeg,image/png,image/heic,image/tiff,image/gif,application/pdf,.msg">
        <ng-template pTemplate="empty">
          <button
            pButton
            [label]="'storedDocuments.fileUpload.addFile' | translate"
            icon="pi pi-plus"
            (click)="documentUploadChooseFile()"
            class="md:hidden p-button bg-primary text-white font-bold w-full justify-center px-8 py-4"
            styleClass="focus:shadow-none rounded-none"></button>
          <section
            class="hidden md:flex flex-col items-center gap-2 border-2 border-light border-dashed rounded-xl p-6">
            <i class="pi pi-file-arrow-up text-primary text-xl"></i
            ><span class="font-app-bold text-sm text-darkest">{{
              "storedDocuments.fileUpload.dragFile" | translate
            }}</span
            ><span class="text-xs">{{ "storedDocuments.fileUpload.or" | translate }}</span
            ><button
              pButton
              (click)="documentUploadChooseFile()"
              class="text-sm text-primary focus:shadow-none rounded-none">
              <span class="underline">{{ "storedDocuments.fileUpload.addFile" | translate }}</span>
            </button>
          </section>
        </ng-template>
        <ng-template
          pTemplate="content"
          let-files
          let-removeFileCallback="removeFileCallback">
          <div *ngIf="files?.length > 0">
            <h2 class="text-black font-app-bold">
              {{ "storedDocuments.addFile" | translate }}
            </h2>
            <ul class="w-full">
              <li
                *ngFor="let file of files"
                class="flex flex-row items-center justify-center mt-4">
                <div class="flex flex-row items-center grow overflow-hidden whitespace-nowrap overflow-ellipsis">
                  <i
                    class="pi text-xl h-7 aspect-square text-center"
                    [ngClass]="fileIcon"></i>
                  <span
                    class="text-severity-low ml-1 font-app-medium overflow-hidden whitespace-nowrap text-ellipsis"
                    >{{ file.name }}</span
                  >
                </div>
                <button
                  pButton
                  icon="pi pi-times"
                  severity="secondary"
                  class="ml-6 text-black"
                  (click)="removeFileCallback()"></button>
              </li>
            </ul>
            <form
              [formGroup]="addFileForm"
              class="w-full">
              <div class="flex flex-col mt-4">
                <label
                  for="fileName"
                  class="font-app-regular"
                  >{{ "storedDocuments.fileForm.nameInput" | translate }} <span class="text-red">*</span></label
                >
                <input
                  pInputText
                  id="fileName"
                  type="text"
                  class="font-app-regular text-black border-2 border-light rounded-md px-4 py-2 mt-2"
                  formControlName="fileNameControlName"
                  maxlength="30"
                  max="30"
                  [placeholder]="'storedDocuments.fileForm.fileNamePlaceholder' | translate" />
                <div
                  *ngIf="
                    addFileForm.get('fileNameControlName')?.invalid && addFileForm.get('fileNameControlName')?.touched
                  "
                  class="text-red-500 mt-1">
                  <span
                    class="text-severity-high text-xs mt-2"
                    *ngIf="addFileForm.get('fileNameControlName')?.errors?.['required']">
                    {{ "storedDocuments.fileForm.fileNameEmptyError" | translate }}
                  </span>
                  <span
                    class="text-severity-high text-xs mt-2"
                    *ngIf="addFileForm.get('fileNameControlName')?.errors?.['specialCharacters']">
                    {{ "storedDocuments.fileForm.fileNameSpecialCharError" | translate }}
                  </span>
                </div>
              </div>
              <div class="flex flex-col mt-4">
                <label
                  for="category"
                  class="font-app-regular"
                  >{{ "storedDocuments.fileForm.categoryInput" | translate }}
                  <span class="text-red">{{ "storedDocuments.required" | translate }}</span></label
                >
                <p-dropdown
                  formControlName="fileCategory"
                  [options]="categories"
                  optionLabel="name"
                  styleClass="w-full border-2 border-light rounded-md mt-2"
                  [placeholder]="'storedDocuments.fileForm.categoryPlaceholder' | translate">
                  <ng-template
                    pTemplate="item"
                    let-category>
                    <div class="p-dropdown-item-container px-3 py-2 gap-2 rounded-md">
                      <span class="flex-initial text-sm text-black">{{
                        category.isCustom
                          ? category.name
                          : (getGenericCategoryTranslationUri(category.name) | translate)
                      }}</span>
                    </div>
                  </ng-template>
                  <ng-template
                    pTemplate="selectedItem"
                    let-category>
                    <span class="p-0">{{
                      category.isCustom ? category.name : (getGenericCategoryTranslationUri(category.name) | translate)
                    }}</span>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="flex flex-col md:flex-row-reverse gap-3 mt-6">
                <button
                  pButton
                  [disabled]="!addFileForm.valid"
                  [label]="'storedDocuments.fileForm.validateButton' | translate"
                  class="p-button bg-primary border-2 border-primary text-white font-bold w-full justify-center px-6 py-3"
                  (click)="saveFile()"></button
                ><button
                  pButton
                  [label]="'storedDocuments.fileForm.cancelButton' | translate"
                  class="p-button bg-transparent border-2 border-primary text-primary font-bold w-full justify-center px-6 py-3"
                  (click)="closeUpload()"></button>
              </div>
            </form>
          </div>
        </ng-template>
        <ng-template pTemplate="file"></ng-template>
      </p-fileUpload>
      <aside
        class="hidden md:block text-xs text-medium_light"
        *ngIf="!documentUpload.files[0]">
        <span>{{ "storedDocuments.fileUpload.format.generalInformations" | translate }}</span>
        <ul class="list-outside list-disc ml-6 mt-2">
          <li>
            {{ "storedDocuments.fileUpload.format.listItem1" | translate }}
          </li>
          <li>
            {{ "storedDocuments.fileUpload.format.listItem2" | translate }}
          </li>
          <li>
            {{ "storedDocuments.fileUpload.format.listItem3" | translate }}
          </li>
        </ul>
      </aside>
    </section>
  </div>
</p-card>
<p-dialog
  [(visible)]="displayErrorDialog"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [draggable]="false"
  [dismissableMask]="true"
  [style]="{ width: '50%' }">
  <ng-template
    pTemplate="header"
    class="flex justify-between">
    <div class="header-name ml-auto mr-auto p-4 bg-lightest rounded-md w-full">
      <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
        {{ "storedDocuments.errorTitle" | translate }}
      </h1>
    </div>
  </ng-template>
  <div *ngIf="showStorageError; else showTypeError">
    <div class="flex flex-col">
      <p class="text-center text-darkest p-2 font-app-regular">
        {{ "storedDocuments.fileUpload.storage.errorStorageText" | translate }}
      </p>
      <button
        pButton
        label="Fermer"
        class="bg-primary text-white p-2 rounded-md flex justify-center mt-4 w-2/4 mx-auto"
        (click)="close()"></button>
    </div>
  </div>
  <ng-template #showTypeError>
    <div class="flex flex-col">
      <p class="text-darkest p-2 font-app-regular ml-1">
        {{ "storedDocuments.fileUpload.format.errorFormat" | translate }}
      </p>
      <ul class="list-outside list-disc ml-6 text-darkest p-2 font-app-regular">
        <li>
          {{ "storedDocuments.fileUpload.format.listItem1" | translate }}
        </li>
        <li>
          {{ "storedDocuments.fileUpload.format.listItem2" | translate }}
        </li>
        <li>
          {{ "storedDocuments.fileUpload.format.listItem3" | translate }}
        </li>
      </ul>
      <button
        pButton
        label="Fermer"
        class="bg-primary text-white p-2 rounded-md flex justify-center mt-4 w-2/4 mx-auto"
        (click)="close()"></button>
    </div>
  </ng-template>
</p-dialog>

